import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import LOOKUP from 'constants/lookup';
import './styles/POSProductCard.css';
import imgDefault from '../../../../images/imgDefault.jpg';
import Button from 'screens/components/basic/Button';
import { MeasurementType } from 'constants/enums';
import Chip from '@mui/material/Chip';
import { generateRanges, getPriceToShow } from 'utils/helpers';

class POSProductCard extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            dialogOpen: false,
            hover: false,
            hoverProductId: 0,
            src: null
        };

        this.setDefaultImg = this.setDefaultImg.bind(this);
    }

    hoverOn = (productId) => {
        this.setState(prevState => {
            return {
                ...prevState,
                hover: true,
                hoverProductId: productId
            };
        });
    }

    hoverOff = () => {
        this.setState(prevState => {
            return {
                ...prevState,
                hover: false,
                hoverProductId: 0
            };
        });
    }

    closeDialog = () => {
        this.setState({ dialogOpen: false });
    }

    addToCart = (product) => {
        this.props.addToCart(product);
    }

    formatString = (string) => {
        if (string.length > 70) {
            string = string.substring(0, 70) + "...";
        }
        return string;
    }

    setDefaultImg = () => {
        this.setState({
            src: imgDefault
        })
    }

    render() {
        const { t } = this.props; 
        let p = this.props;
        let item = p.item;
        const labels = !item ? {} : generateRanges(item);
        let src = item.imagesUrls == null ? imgDefault : item.imagesUrls;
        let priceToShow = getPriceToShow(p.isMember, item, p.eliteMemberEndDate, p.isEmployee, p.isHighTide, p.isInspired);
        let isUnitProduct = item.measurementType === MeasurementType.Unit || item.measurementType === MeasurementType.GramUnit;
        let labelQuantity = '';

        if (isUnitProduct) {
            if (item.quantity > p.doNotShowUnitProductQuantityOver) {
                labelQuantity = `${p.doNotShowUnitProductQuantityOver}+`;
            } else {
                labelQuantity = `${parseInt(item.quantity)}`;
            }
        } else {
            if (item.quantity > p.doNotShowWeightProductQuantityOver) {
                labelQuantity = `${p.doNotShowWeightProductQuantityOver}+`;
            } else {
                labelQuantity = `${(Math.round(item.quantity * 10) / 10).toFixed(1)}`;
            }
        }

        return (
            <div className="shop_product p-0 fluid_image" style={{ position: 'relative' }}>
                <div className="product_action" onMouseEnter={() => this.hoverOn(item.id)} onMouseLeave={this.hoverOff}>
                    <div className="product_img_container">
                        <img
                            src={this.state.src ? this.state.src : src}
                            alt="cannaImg"
                            className="card_product_img"
                            onError={() => this.setDefaultImg()}
                        />
                    </div>
                    {item.priceMatrix == null ? (
                        <div className="shop_product_price">
                            ${priceToShow ? priceToShow.toFixed(2) : Number(0).toFixed(2)}&nbsp;
                            <Chip style={{ height: 21, paddingRight: '0px !important', paddingLeft: '0px' }} className="POSUnitNums"
                            label={labelQuantity == '1' ? labelQuantity + ' ' + t('pos.productCard.unit') : labelQuantity + ' ' + t('pos.productCard.units')}
                            />
                        </div>
                    ) : (
                        <div className="shop_product_price"></div>
                    )}
                </div>
                <div className="product_card pt-3">
                    <div className="shop_product_name">{item.name ? this.formatString(item.name) : null} {item.isElite && <span className="eliteProductBadge">E</span>}</div>
                    <div className="clear"></div>
                    <div className="product_description_total">
                        <div className="product_description_category">
                            <Chip className="product_description_font font_jakarta" style={{ margin: 'auto', height: 25 }}
                                label={item.category ? item.category : ''}
                            />
                        </div>
                    </div>
                    {p.isVape ? null : (
                        <div style={{ width: '100%', margin: 'auto', display: 'flex', justifyContent: 'center' }}>
                            <div className="product_description font_jakarta">
                                <span className="font_jakarta" style={{ textAlign: 'center' }}>
                                    {t('pos.productCard.species')}
                                </span>
                                <br />
                                <span className="font_jakarta" style={{ fontWeight: 'bold' }}>
                                    {item.species !== 0 ? LOOKUP.species.find(_ => _.value == item.species).text : t('pos.productCard.na')}
                                </span>
                            </div>
                            <div className="product_description font_jakarta">
                                <span>{t('pos.productCard.thcProduct')}</span>
                                <br />
                                <span className="font_jakarta" style={{ fontWeight: 'bold' }}>
                                    {labels.thcLabel}
                                </span>
                            </div>
                            <div className="product_description endfloat font_jakarta">
                                <span>{t('pos.productCard.cbd')}</span>
                                <br />
                                <span className="font_jakarta" style={{ fontWeight: 'bold' }}>
                                    {labels.cbdLabel}
                                </span>
                            </div>
                        </div>
                    )}
                    <div id="addToOrder" className="mt-3 add_cart_btn">
                        <Button
                            label={t('pos.productCard.addToOrder')}
                            className="add_to_order_button"
                            primary={true}
                            onTouchTap={() => p.openDetailLog()}
                            key={p.key}
                            disabled={p.fulfillmentMustScanAllForComplete && p.fulfillmentDone}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        fulfillmentDone: state.entity.posOrder ? state.entity.posOrder.fulfillmentDone : false,
        fulfillmentMustScanAllForComplete: state.common.applicationSettings.fulfillmentMustScanAllForComplete,
        isMember: state.entity.posOrder ? (state.entity.posOrder.patientId > 0 ? true : false) : false,
        isEmployee: state.entity.posOrder && state.entity.posOrder.patientIsEmployee,
        doNotShowUnitProductQuantityOver: state.common.applicationSettings.doNotShowUnitProductQuantityOver,
        isVape: state.common.applicationSettings.isVape,
        eliteMemberEndDate: state.entity.posOrder ? state.entity.posOrder.eliteMemberEndDate : null,
        isHighTide: state.common.applicationSettings.isHighTide,
        isInspired: state.common.applicationSettings.isInspired
    };
}

function mapDispatchToProps(dispatch) {
    return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSProductCard))